(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-policy"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cookie-preferences]');
    if (!button || button.disabled) return;
    const error = button.parentElement.querySelector('[data-cookie-preferences-error]');
    button.disabled = true;
    error.hidden = true;
    try {
      for (let attempt = 0; attempt < 20 && !window.privacyBanner?.showPreferences; attempt += 1) {
        await new Promise((resolve) => setTimeout(resolve, 250));
      }
      if (!window.privacyBanner?.showPreferences) throw new Error('Preferences unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
